














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { investmentEntity } from '@store/modules/investment-entity';
import NotificationDropdownItem from '@components/header/navigation/notification-dropdown-item.vue';
import { NotificationResponse } from 'types/header';
import { trackMixpanel } from '@utils/analytics';

@Component({
	components: {
		NotificationDropdownItem
	}
})
export default class NotificationDropdown extends Vue {
	$refs!: {
		notificationDropdown: HTMLElement;
	};

	@Prop()
	expanded!: boolean;

	lastViewedCookieKey = 'com.fundrise.notifications.lastViewed';

	lastViewCookie = this.$cookies.get(this.lastViewedCookieKey);

	get userNotifications(): NotificationResponse {
		return investmentEntity.notifications;
	}

	get numNewNotifications(): number {
		if (this.lastViewCookie && this.lastViewCookie > this.userNotifications.generatedTimestamp) {
			return 0;
		} else if (this.userNotifications.lastNotificationView) {
			return this.userNotifications.notifications.filter((notification) => {
				return notification.displayDateMillis >= this.userNotifications.lastNotificationView;
			}).length;
		} else {
			return this.userNotifications.notifications.length;
		}
	}

	get dropdownExpanded(): boolean {
		return this.expanded;
	}

	@Watch('dropdownExpanded')
	onDropdownExpandedChange(expand: boolean): void {
		if (expand) {
			document.addEventListener('click', this.clickOutsideHandler);

			this.updateLastViewedNotification();

			trackMixpanel('Notification Dropdown Opened', {
				investmentEntityId: `${window.fundriseApp.investmentEntityId}`
			});
		} else {
			document.removeEventListener('click', this.clickOutsideHandler);
		}
	}

	clickOutsideHandler(event: MouseEvent): void {
		if (this.$refs.notificationDropdown && !this.$refs.notificationDropdown.contains(event.target as Node)) {
			this.$emit('expandNotificationDropdown', false);
		}
	}

	toggleDropdown(): void {
		this.updateLastViewedNotification();
		this.$emit('expandNotificationDropdown', !this.expanded);
	}

	async updateLastViewedNotification(): Promise<void> {
		if (this.numNewNotifications > 0) {
			await investmentEntity.updateNotificationsView();

			this.$cookies.set(this.lastViewedCookieKey, Date.now(), undefined, '/');
		}
	}
}
